import React from 'react';
import { useSelector } from 'react-redux';

/**
 * Component to show wallet reconnection status
 * This provides visual feedback when the app is attempting to reconnect a wallet
 */
export const WalletReconnectionIndicator = () => {
  const { isReconnecting, reconnectionError, wallet } = useSelector((state) => ({
    isReconnecting: state.auth.isReconnecting,
    reconnectionError: state.auth.reconnectionError,
    wallet: state.auth.wallet
  }));

  if (!isReconnecting && !reconnectionError) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-50">
      {isReconnecting && (
        <div className="bg-blue-500 text-white px-4 py-2 rounded-lg shadow-lg flex items-center space-x-2">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
          <span>Reconnecting {wallet} wallet...</span>
        </div>
      )}
      
      {reconnectionError && (
        <div className="bg-red-500 text-white px-4 py-2 rounded-lg shadow-lg">
          <div className="flex items-center space-x-2">
            <span>⚠️</span>
            <span>Wallet reconnection failed</span>
          </div>
          <div className="text-sm mt-1 opacity-90">
            {reconnectionError}
          </div>
        </div>
      )}
    </div>
  );
};
